const hi = {
  meta: { code: "hi", label: "हिन्दी" },
  nav: {
    brand: "IQ Log",
    diagnostics: "मूल्यांकन",
    mypage: "मेरा पेज",
    login: "लॉग इन",
    register: "साइन अप",
    logout: "लॉग आउट",
  },
  hero: {
    eyebrow: "मूल्यांकन प्लेटफ़ॉर्म",
    title: "मूल्यांकनों के माध्यम से अपने तत्व की खोज करें",
    subtitle1: "सोच, व्यक्तित्व, और योग्यता — पूरी तरह से देखी गई",
    subtitle2: "5 मिनट में अपनी ताकत और कमज़ोरी देखें",
    subtitle3: "हर मूल्यांकन आपका डेटा बन जाता है",
    cta_primary: "मूल्यांकन शुरू करें",
    cta_secondary: "कैटलॉग देखें",
    disclaimer: "संदर्भ सूचना / गैर-चिकित्सीय",
  },
  categories: {
    ability: "क्षमता",
    personality: "व्यक्तित्व",
    mental: "मानसिक",
    aptitude: "योग्यता",
    traits: "विशेषताएँ",
  },
  catalog: {
    title: "सभी मूल्यांकन",
    subtitle: "17 परीक्षण / 5 श्रेणियां",
    filter_all: "सभी",
    duration: "मिनट",
    difficulty: { easy: "आसान", medium: "मध्यम", hard: "कठिन" },
    question_count: "प्रश्न",
    start: "शुरू",
  },
  quiz: {
    question: "प्रश्न",
    of: "/",
    next: "अगला",
    prev: "पीछे",
    submit: "परिणाम देखें",
    progress: "प्रगति",
    exit: "बाहर",
    required: "एक विकल्प चुनें",
    submitting: "अंकन हो रहा है…",
  },
  result: {
    overall: "कुल स्कोर",
    type_label: "प्रकार",
    share_link: "लिंक से परिणाम साझा करें",
    back_to_catalog: "अन्य मूल्यांकन लें",
    view_mypage: "मेरे पेज पर इतिहास देखें",
    premium_title: "विस्तृत विश्लेषण अनलॉक करें",
    premium_subtitle: "प्रीमियम के साथ, आप नीचे सब कुछ देखेंगे:",
    feature_breakdown: "विस्तृत स्कोर ब्रेकडाउन",
    feature_cause: "मूल कारण विश्लेषण",
    feature_plan: "सुधार योजना",
    feature_pdf: "PDF रिपोर्ट (A4)",
    price: "¥980",
    price_note: "(Stripe के माध्यम से सुरक्षित भुगतान)",
    price_free: "मुफ़्त",
    price_free_note: "(सीमित समय · 100% मुफ़्त)",
    unlock_button: "Stripe से भुगतान",
    unlock_button_free: "मुफ़्त में अनलॉक",
    unlock_requires_auth: "अनलॉक करने के लिए साइन इन करें",
    unlock_save_first: "पहले खाते से परिणाम सहेजें",
    unlocking: "Stripe पर रीडायरेक्ट हो रहा है…",
    free_only_notice: "मुफ़्त संस्करण केवल कुल स्कोर और प्रकार दिखाता है।",
    compliance_note:
      "यह मूल्यांकन केवल संदर्भ सूचना है और चिकित्सीय निदान नहीं। हम निश्चयात्मक या डर बढ़ाने वाली भाषा से बचते हैं।",
  },
  premium: {
    title: "विस्तृत विश्लेषण रिपोर्ट",
    summary: "समग्र सारांश",
    strengths: "ताकत",
    weaknesses: "विकास क्षेत्र",
    improvements: "सुधार योजना",
    dimensions: "आयामी स्कोर",
    download_pdf: "PDF डाउनलोड",
    pdf_soon: "PDF एक्सपोर्ट (जल्द ही)",
  },
  mypage: {
    title: "मेरा पेज",
    subtitle: "आपका इतिहास, स्कोर रुझान और बैज",
    total: "कुल मूल्यांकन",
    average: "औसत स्कोर",
    premium_count: "अनलॉक",
    categories_covered: "कवर श्रेणियाँ",
    trend_title: "स्कोर रुझान",
    history_title: "इतिहास",
    badges_title: "बैज",
    unlock_3_title: "समग्र विश्लेषण अनलॉक",
    unlock_3_desc: "{n} और मूल्यांकन लें समग्र विश्लेषण अनलॉक करने के लिए",
    unlocked: "समग्र विश्लेषण अनलॉक हो गया",
    no_history: "अभी तक कोई मूल्यांकन नहीं — पहला अभी लें।",
  },
  auth: {
    login_title: "लॉग इन",
    register_title: "खाता बनाएं",
    email: "ईमेल",
    password: "पासवर्ड (न्यूनतम 6 अक्षर)",
    name: "प्रदर्शन नाम (वैकल्पिक)",
    login_btn: "लॉग इन",
    register_btn: "साइन अप",
    go_register: "कोई खाता नहीं? साइन अप",
    go_login: "खाता है? लॉग इन",
    anon_note: "मूल्यांकन मुफ़्त और अनाम हैं। केवल परिणाम सहेजने और प्रीमियम अनलॉक करने के लिए खाता आवश्यक है।",
    success_register: "खाता बनाया गया",
    success_login: "साइन इन हो गया",
    consent_section: "सहमति",
    consent_required: "आवश्यक मद स्वीकार करें",
    accept_terms_pre: "मैं सहमत हूँ",
    terms_link: "सेवा की शर्तें",
    accept_terms_post: "",
    accept_privacy_pre: "मैंने पढ़ी है",
    privacy_link: "गोपनीयता नीति",
    accept_privacy_post: "और अपने व्यक्तिगत डेटा के प्रसंस्करण के लिए सहमति देता हूँ",
    accept_age: "मैं 16 वर्ष या उससे अधिक हूँ (या मेरे कानूनी अभिभावक की सहमति है)",
    accept_marketing: "नए मूल्यांकन और प्रचार ईमेल भेजें",
    optional: "वैकल्पिक",
  },
  landing: {
    status_online: "सिस्टम ऑनलाइन",
    status_subtitle: "DIAGNOSTIC OS v2.0",
    status_tests: "17 परीक्षण",
    status_langs: "14 भाषाएँ",
    status_ai: "AI · सक्रिय",
    title_line1: "अपने तत्व को खोजें",
    title_line2: "5 मिनट में।",
    trust_diagnostics: "मूल्यांकन",
    trust_languages: "भाषाएँ",
    trust_per_test: "प्रति परीक्षण",
    hud_readout: "मुख्य रीडआउट",
    hud_score_unit: "/100 कुल",
    hud_band: "बैंड · GOLD",
    hud_dimensions: "आयाम",
    hud_dimensions_status: "3 / 3 लाइव",
    hud_syslog: "सिस्टम लॉग",
    cat_eyebrow: "// श्रेणियाँ",
    cat_title_pre: "5 श्रेणियाँ · ",
    cat_title_highlight: "17 मूल्यांकन",
    view_all: "सभी देखें",
    proto_eyebrow: "// प्रोटोकॉल",
    proto_title_pre: "3 चरणों में ",
    proto_title_highlight: "अपनी तत्व खोलें।",
    step1_title: "एक परीक्षण चुनें",
    step1_body: "17 में से चुनें। गुमनाम शुरू।",
    step2_title: "5 मिनट में उत्तर",
    step2_body: "प्रगति बार और बैज आपको प्रेरित करते हैं।",
    step3_title: "AI से अनलॉक",
    step3_body: "विस्तृत स्कोर, योजना और PDF।",
    final_eyebrow: "// तैयार?",
    final_title_pre: "आपका तत्व ",
    final_title_highlight: "5 मिनट में।",
    final_subtitle: "5 मिनट में अपनी ताकत और कमज़ोरी देखें",
    final_button: "अभी मूल्यांकन शुरू",
  },
  footer: {
    tagline: "आपकी सोच, व्यक्तित्व और योग्यता का मूल्यांकन प्लेटफ़ॉर्म",
    rights: "सर्वाधिकार सुरक्षित।",
    legal: "क़ानूनी",
    privacy: "गोपनीयता",
    terms: "शर्तें",
    about_label: "हमारे बारे में / कंपनी",
    compliance_label: "अंतर्राष्ट्रीय अनुपालन",
    tokushoho_label: "जापान व्यापार अधिनियम प्रकटीकरण",
    data_protection_label: "डेटा सुरक्षा (अंतर्राष्ट्रीय)",
    data_request_label: "डेटा हटाएँ / ऑप्ट-आउट",
    disclaimer_label: "अस्वीकरण",
    disclaimer_full:
      "यह सेवा केवल संदर्भ के लिए है और चिकित्सीय निदान नहीं। हम निश्चयात्मक या डर बढ़ाने वाली भाषा का प्रयोग नहीं करते।",
  },
  badges: {
    "first-diagnosis": "पहला मूल्यांकन",
    "three-diagnostics": "3 मूल्यांकन",
    "five-diagnostics": "5 मूल्यांकन",
    "ten-diagnostics": "10 मूल्यांकन",
    "high-performer": "उच्च प्रदर्शनकर्ता",
    "premium-user": "प्रीमियम उपयोगकर्ता",
  },
  lang_selector: "भाषा",
  payment: {
    processing_title: "भुगतान सत्यापित हो रहा है…",
    processing_subtitle: "Stripe से वापस आए — विस्तृत विश्लेषण बनाया जा रहा है (20 सेकंड तक)",
    success: "भुगतान पुष्टि हुआ — प्रीमियम अनलॉक",
    expired: "चेकआउट सत्र समाप्त। पुनः प्रयास करें।",
    error: "भुगतान सत्यापन विफल। कृपया सहायता से संपर्क करें।",
  },
};
export default hi;
